var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioLineStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 20,
    viewBox: "0 0 297 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_502_107870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8857 14.1066C36.1596 14.1066 35.5707 13.7466 35.5707 13.3028V6.87189C35.5707 6.42806 36.1596 6.06804 36.8857 6.06804C37.6117 6.06804 38.2006 6.42806 38.2006 6.87189V13.3028C38.2006 13.7466 37.6117 14.1066 36.8857 14.1066ZM32.3562 15.4464V4.72827C32.3562 4.28444 31.7672 3.92442 31.0412 3.92442C30.3152 3.92442 29.7263 4.28444 29.7263 4.72827V15.4464C29.7263 15.8902 30.3152 16.2502 31.0412 16.2502C31.7672 16.2502 32.3562 15.8902 32.3562 15.4464ZM26.5126 12.2309V7.9437C26.5126 7.49987 25.9237 7.13985 25.1977 7.13985C24.4716 7.13985 23.8827 7.49987 23.8827 7.9437V12.2309C23.8827 12.6748 24.4716 13.0348 25.1977 13.0348C25.9237 13.0348 26.5126 12.6748 26.5126 12.2309ZM20.6682 16.5182V3.65646C20.6682 3.21263 20.0792 2.8526 19.3532 2.8526C18.6272 2.8526 18.0383 3.21263 18.0383 3.65646V16.5182C18.0383 16.962 18.6272 17.322 19.3532 17.322C20.0792 17.322 20.6682 16.962 20.6682 16.5182ZM14.8237 18.6618V1.51284C14.8237 1.06901 14.2348 0.708984 13.5088 0.708984C12.7828 0.708984 12.1939 1.06901 12.1939 1.51284V18.6618C12.1939 19.1056 12.7828 19.4657 13.5088 19.4657C14.2348 19.4657 14.8237 19.1056 14.8237 18.6618ZM8.98016 14.3746V5.80008C8.98016 5.35625 8.39125 4.99623 7.66523 4.99623C6.93921 4.99623 6.3503 5.35625 6.3503 5.80008V14.3746C6.3503 14.8184 6.93921 15.1784 7.66523 15.1784C8.39125 15.1784 8.98016 14.8184 8.98016 14.3746ZM3.13572 13.3028V6.87189C3.13572 6.42806 2.54681 6.06804 1.82079 6.06804C1.09477 6.06804 0.505859 6.42806 0.505859 6.87189V13.3028C0.505859 13.7466 1.09477 14.1066 1.82079 14.1066C2.54681 14.1066 3.13572 13.7466 3.13572 13.3028Z",
    fill: "url(#paint0_linear_502_107870)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_502_107870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.8681 14.1066C79.1421 14.1066 78.5532 13.7466 78.5532 13.3028V6.87189C78.5532 6.42806 79.1421 6.06804 79.8681 6.06804C80.5941 6.06804 81.183 6.42806 81.183 6.87189V13.3028C81.183 13.7466 80.5941 14.1066 79.8681 14.1066ZM75.3386 15.4464V4.72827C75.3386 4.28444 74.7497 3.92442 74.0236 3.92442C73.2976 3.92442 72.7087 4.28444 72.7087 4.72827V15.4464C72.7087 15.8902 73.2976 16.2502 74.0236 16.2502C74.7497 16.2502 75.3386 15.8902 75.3386 15.4464ZM69.495 12.2309V7.9437C69.495 7.49987 68.9061 7.13985 68.1801 7.13985C67.4541 7.13985 66.8652 7.49987 66.8652 7.9437V12.2309C66.8652 12.6748 67.4541 13.0348 68.1801 13.0348C68.9061 13.0348 69.495 12.6748 69.495 12.2309ZM63.6506 16.5182V3.65646C63.6506 3.21263 63.0617 2.8526 62.3356 2.8526C61.6096 2.8526 61.0207 3.21263 61.0207 3.65646V16.5182C61.0207 16.962 61.6096 17.322 62.3356 17.322C63.0617 17.322 63.6506 16.962 63.6506 16.5182ZM57.8061 18.6618V1.51284C57.8061 1.06901 57.2172 0.708984 56.4912 0.708984C55.7652 0.708984 55.1763 1.06901 55.1763 1.51284V18.6618C55.1763 19.1056 55.7652 19.4657 56.4912 19.4657C57.2172 19.4657 57.8061 19.1056 57.8061 18.6618ZM51.9626 14.3746V5.80008C51.9626 5.35625 51.3737 4.99623 50.6477 4.99623C49.9216 4.99623 49.3327 5.35625 49.3327 5.80008V14.3746C49.3327 14.8184 49.9216 15.1784 50.6477 15.1784C51.3737 15.1784 51.9626 14.8184 51.9626 14.3746ZM46.1181 13.3028V6.87189C46.1181 6.42806 45.5292 6.06804 44.8032 6.06804C44.0772 6.06804 43.4883 6.42806 43.4883 6.87189V13.3028C43.4883 13.7466 44.0772 14.1066 44.8032 14.1066C45.5292 14.1066 46.1181 13.7466 46.1181 13.3028Z",
    fill: "url(#paint1_linear_502_107870)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_502_107870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.851 14.1066C122.124 14.1066 121.536 13.7466 121.536 13.3028V6.87189C121.536 6.42806 122.124 6.06804 122.851 6.06804C123.577 6.06804 124.165 6.42806 124.165 6.87189V13.3028C124.165 13.7466 123.577 14.1066 122.851 14.1066ZM118.321 15.4464V4.72827C118.321 4.28444 117.732 3.92442 117.006 3.92442C116.28 3.92442 115.691 4.28444 115.691 4.72827V15.4464C115.691 15.8902 116.28 16.2502 117.006 16.2502C117.732 16.2502 118.321 15.8902 118.321 15.4464ZM112.477 12.2309V7.9437C112.477 7.49987 111.889 7.13985 111.163 7.13985C110.436 7.13985 109.848 7.49987 109.848 7.9437V12.2309C109.848 12.6748 110.436 13.0348 111.163 13.0348C111.889 13.0348 112.477 12.6748 112.477 12.2309ZM106.633 16.5182V3.65646C106.633 3.21263 106.044 2.8526 105.318 2.8526C104.592 2.8526 104.003 3.21263 104.003 3.65646V16.5182C104.003 16.962 104.592 17.322 105.318 17.322C106.044 17.322 106.633 16.962 106.633 16.5182ZM100.789 18.6618V1.51284C100.789 1.06901 100.2 0.708984 99.4736 0.708984C98.7476 0.708984 98.1587 1.06901 98.1587 1.51284V18.6618C98.1587 19.1056 98.7476 19.4657 99.4736 19.4657C100.2 19.4657 100.789 19.1056 100.789 18.6618ZM94.945 14.3746V5.80008C94.945 5.35625 94.3561 4.99623 93.6301 4.99623C92.9041 4.99623 92.3151 5.35625 92.3151 5.80008V14.3746C92.3151 14.8184 92.9041 15.1784 93.6301 15.1784C94.3561 15.1784 94.945 14.8184 94.945 14.3746ZM89.1006 13.3028V6.87189C89.1006 6.42806 88.5117 6.06804 87.7856 6.06804C87.0596 6.06804 86.4707 6.42806 86.4707 6.87189V13.3028C86.4707 13.7466 87.0596 14.1066 87.7856 14.1066C88.5117 14.1066 89.1006 13.7466 89.1006 13.3028Z",
    fill: "url(#paint2_linear_502_107870)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_b_502_107870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.833 14.1066C165.107 14.1066 164.518 13.7466 164.518 13.3028V6.87189C164.518 6.42806 165.107 6.06804 165.833 6.06804C166.559 6.06804 167.148 6.42806 167.148 6.87189V13.3028C167.148 13.7466 166.559 14.1066 165.833 14.1066ZM161.303 15.4464V4.72827C161.303 4.28444 160.715 3.92442 159.988 3.92442C159.262 3.92442 158.674 4.28444 158.674 4.72827V15.4464C158.674 15.8902 159.262 16.2502 159.988 16.2502C160.715 16.2502 161.303 15.8902 161.303 15.4464ZM155.46 12.2309V7.9437C155.46 7.49987 154.871 7.13985 154.145 7.13985C153.419 7.13985 152.83 7.49987 152.83 7.9437V12.2309C152.83 12.6748 153.419 13.0348 154.145 13.0348C154.871 13.0348 155.46 12.6748 155.46 12.2309ZM149.615 16.5182V3.65646C149.615 3.21263 149.027 2.8526 148.3 2.8526C147.574 2.8526 146.986 3.21263 146.986 3.65646V16.5182C146.986 16.962 147.574 17.322 148.3 17.322C149.027 17.322 149.615 16.962 149.615 16.5182ZM143.771 18.6618V1.51284C143.771 1.06901 143.182 0.708984 142.456 0.708984C141.73 0.708984 141.141 1.06901 141.141 1.51284V18.6618C141.141 19.1056 141.73 19.4657 142.456 19.4657C143.182 19.4657 143.771 19.1056 143.771 18.6618ZM137.927 14.3746V5.80008C137.927 5.35625 137.339 4.99623 136.612 4.99623C135.886 4.99623 135.298 5.35625 135.298 5.80008V14.3746C135.298 14.8184 135.886 15.1784 136.612 15.1784C137.339 15.1784 137.927 14.8184 137.927 14.3746ZM132.083 13.3028V6.87189C132.083 6.42806 131.494 6.06804 130.768 6.06804C130.042 6.06804 129.453 6.42806 129.453 6.87189V13.3028C129.453 13.7466 130.042 14.1066 130.768 14.1066C131.494 14.1066 132.083 13.7466 132.083 13.3028Z",
    fill: "url(#paint3_linear_502_107870)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_b_502_107870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.813 14.1066C208.087 14.1066 207.498 13.7466 207.498 13.3028V6.87189C207.498 6.42806 208.087 6.06804 208.813 6.06804C209.539 6.06804 210.128 6.42806 210.128 6.87189V13.3028C210.128 13.7466 209.539 14.1066 208.813 14.1066ZM204.284 15.4464V4.72827C204.284 4.28444 203.695 3.92442 202.969 3.92442C202.243 3.92442 201.654 4.28444 201.654 4.72827V15.4464C201.654 15.8902 202.243 16.2502 202.969 16.2502C203.695 16.2502 204.284 15.8902 204.284 15.4464ZM198.44 12.2309V7.9437C198.44 7.49987 197.851 7.13985 197.125 7.13985C196.399 7.13985 195.81 7.49987 195.81 7.9437V12.2309C195.81 12.6748 196.399 13.0348 197.125 13.0348C197.851 13.0348 198.44 12.6748 198.44 12.2309ZM192.596 16.5182V3.65646C192.596 3.21263 192.007 2.8526 191.281 2.8526C190.555 2.8526 189.966 3.21263 189.966 3.65646V16.5182C189.966 16.962 190.555 17.322 191.281 17.322C192.007 17.322 192.596 16.962 192.596 16.5182ZM186.751 18.6618V1.51284C186.751 1.06901 186.163 0.708984 185.437 0.708984C184.711 0.708984 184.122 1.06901 184.122 1.51284V18.6618C184.122 19.1056 184.711 19.4657 185.437 19.4657C186.163 19.4657 186.751 19.1056 186.751 18.6618ZM180.908 14.3746V5.80008C180.908 5.35625 180.319 4.99623 179.593 4.99623C178.867 4.99623 178.278 5.35625 178.278 5.80008V14.3746C178.278 14.8184 178.867 15.1784 179.593 15.1784C180.319 15.1784 180.908 14.8184 180.908 14.3746ZM175.063 13.3028V6.87189C175.063 6.42806 174.475 6.06804 173.749 6.06804C173.023 6.06804 172.434 6.42806 172.434 6.87189V13.3028C172.434 13.7466 173.023 14.1066 173.749 14.1066C174.475 14.1066 175.063 13.7466 175.063 13.3028Z",
    fill: "url(#paint4_linear_502_107870)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_b_502_107870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.796 14.1066C251.07 14.1066 250.481 13.7466 250.481 13.3028V6.87189C250.481 6.42806 251.07 6.06804 251.796 6.06804C252.522 6.06804 253.111 6.42806 253.111 6.87189V13.3028C253.111 13.7466 252.522 14.1066 251.796 14.1066ZM247.266 15.4464V4.72827C247.266 4.28444 246.677 3.92442 245.951 3.92442C245.225 3.92442 244.636 4.28444 244.636 4.72827V15.4464C244.636 15.8902 245.225 16.2502 245.951 16.2502C246.677 16.2502 247.266 15.8902 247.266 15.4464ZM241.423 12.2309V7.9437C241.423 7.49987 240.834 7.13985 240.108 7.13985C239.382 7.13985 238.793 7.49987 238.793 7.9437V12.2309C238.793 12.6748 239.382 13.0348 240.108 13.0348C240.834 13.0348 241.423 12.6748 241.423 12.2309ZM235.578 16.5182V3.65646C235.578 3.21263 234.989 2.8526 234.263 2.8526C233.537 2.8526 232.948 3.21263 232.948 3.65646V16.5182C232.948 16.962 233.537 17.322 234.263 17.322C234.989 17.322 235.578 16.962 235.578 16.5182ZM229.734 18.6618V1.51284C229.734 1.06901 229.145 0.708984 228.419 0.708984C227.693 0.708984 227.104 1.06901 227.104 1.51284V18.6618C227.104 19.1056 227.693 19.4657 228.419 19.4657C229.145 19.4657 229.734 19.1056 229.734 18.6618ZM223.89 14.3746V5.80008C223.89 5.35625 223.301 4.99623 222.575 4.99623C221.849 4.99623 221.26 5.35625 221.26 5.80008V14.3746C221.26 14.8184 221.849 15.1784 222.575 15.1784C223.301 15.1784 223.89 14.8184 223.89 14.3746ZM218.046 13.3028V6.87189C218.046 6.42806 217.457 6.06804 216.731 6.06804C216.005 6.06804 215.416 6.42806 215.416 6.87189V13.3028C215.416 13.7466 216.005 14.1066 216.731 14.1066C217.457 14.1066 218.046 13.7466 218.046 13.3028Z",
    fill: "url(#paint5_linear_502_107870)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_b_502_107870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.778 14.1066C294.052 14.1066 293.463 13.7466 293.463 13.3028V6.87189C293.463 6.42806 294.052 6.06804 294.778 6.06804C295.504 6.06804 296.093 6.42806 296.093 6.87189V13.3028C296.093 13.7466 295.504 14.1066 294.778 14.1066ZM290.249 15.4464V4.72827C290.249 4.28444 289.66 3.92442 288.934 3.92442C288.208 3.92442 287.619 4.28444 287.619 4.72827V15.4464C287.619 15.8902 288.208 16.2502 288.934 16.2502C289.66 16.2502 290.249 15.8902 290.249 15.4464ZM284.405 12.2309V7.9437C284.405 7.49987 283.816 7.13985 283.09 7.13985C282.364 7.13985 281.775 7.49987 281.775 7.9437V12.2309C281.775 12.6748 282.364 13.0348 283.09 13.0348C283.816 13.0348 284.405 12.6748 284.405 12.2309ZM278.561 16.5182V3.65646C278.561 3.21263 277.972 2.8526 277.246 2.8526C276.52 2.8526 275.931 3.21263 275.931 3.65646V16.5182C275.931 16.962 276.52 17.322 277.246 17.322C277.972 17.322 278.561 16.962 278.561 16.5182ZM272.716 18.6618V1.51284C272.716 1.06901 272.127 0.708984 271.401 0.708984C270.675 0.708984 270.086 1.06901 270.086 1.51284V18.6618C270.086 19.1056 270.675 19.4657 271.401 19.4657C272.127 19.4657 272.716 19.1056 272.716 18.6618ZM266.873 14.3746V5.80008C266.873 5.35625 266.284 4.99623 265.558 4.99623C264.832 4.99623 264.243 5.35625 264.243 5.80008V14.3746C264.243 14.8184 264.832 15.1784 265.558 15.1784C266.284 15.1784 266.873 14.8184 266.873 14.3746ZM261.028 13.3028V6.87189C261.028 6.42806 260.439 6.06804 259.713 6.06804C258.987 6.06804 258.398 6.42806 258.398 6.87189V13.3028C258.398 13.7466 258.987 14.1066 259.713 14.1066C260.439 14.1066 261.028 13.7466 261.028 13.3028Z",
    fill: "url(#paint6_linear_502_107870)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_502_107870",
    x: -31.7654,
    y: -31.5622,
    width: 102.238,
    height: 83.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_502_107870",
    x: 11.217,
    y: -31.5622,
    width: 102.238,
    height: 83.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_502_107870",
    x: 54.1995,
    y: -31.5622,
    width: 102.238,
    height: 83.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_b_502_107870",
    x: 97.1819,
    y: -31.5622,
    width: 102.238,
    height: 83.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_b_502_107870",
    x: 140.162,
    y: -31.5622,
    width: 102.238,
    height: 83.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_b_502_107870",
    x: 183.145,
    y: -31.5622,
    width: 102.238,
    height: 83.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_b_502_107870",
    x: 226.127,
    y: -31.5622,
    width: 102.238,
    height: 83.2993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 16.1356
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_502_107870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_502_107870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_107870",
    x1: 43.597,
    y1: 19.4657,
    x2: -17.4942,
    y2: 19.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_107870",
    x1: 86.5795,
    y1: 19.4657,
    x2: 25.4882,
    y2: 19.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_107870",
    x1: 129.562,
    y1: 19.4657,
    x2: 68.4706,
    y2: 19.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_502_107870",
    x1: 172.544,
    y1: 19.4657,
    x2: 111.453,
    y2: 19.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_502_107870",
    x1: 215.525,
    y1: 19.4657,
    x2: 154.434,
    y2: 19.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_502_107870",
    x1: 258.507,
    y1: 19.4657,
    x2: 197.416,
    y2: 19.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_502_107870",
    x1: 301.49,
    y1: 19.4657,
    x2: 240.398,
    y2: 19.0888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382639,
    stopColor: "#596451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561006,
    stopColor: "#1199A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75484,
    stopColor: "#74C27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1199A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioLineStyle);
export default __webpack_public_path__ + "static/media/AudioLineStyle.cf42c477f94900006cfbd8384fffc4ab.svg";
export { ForwardRef as ReactComponent };